/* eslint-disable */ 
/** 
 * Flickity accessibility patch. Adds aria-hidden to slides which are outside the horizontal viewport.
 * 
 * Adapted from https://gist.github.com/neodigm/bf64202df7ff854c910977eb1f2515a0
 */
$( window ).on("load", function() {

class FlickPatch {  //  Flick Carousel ARIA-HIDDEN observer
    constructor(document, selector) {
        this.document = document; this.selector = selector;
        this.sliders = [];
    }
    init() {
        this.sliders = Array.from( this.document.querySelectorAll( this.selector ))
        if( this.sliders.length ){
            this.sliders.forEach((slider) => {
                const mutationObserver = new MutationObserver(() => {
                    if(flickPatch && typeof flickPatch.removeAttr === "function") {
                        flickPatch.removeAttr(slider);
                    }
                });
                mutationObserver.observe(slider, { attributes: true, childList: true, subtree: true });
                this.removeAttr(slider);
            })            
        }
        return this;
    }
    removeAttr(slider) {
        const threshold = 0.1;
        if(slider) {
            [...slider.querySelectorAll(".flickity-cell")].forEach((slide) => {
                var rect = slide.getBoundingClientRect();
                const overlap = rect.width * threshold;
                var viewWidth = Math.max(document.documentElement.clientWidth, window.innerWidth);
                if (!(rect.right < 0 + overlap || rect.left >= viewWidth - overlap)) {
                    if(slide.getAttribute("aria-hidden")) {
                        slide.removeAttribute("aria-hidden")
                    }
                } else {
                    if(!slide.getAttribute("aria-hidden")) {
                        slide.setAttribute("aria-hidden", "true")
                    }
                }
            })
        }
    }
}
    //. Usage
    let flickPatch = {}

    flickPatch = new FlickPatch(document, ".flickity-slider")
    flickPatch.init()   
})


/* eslint-enable */

